/*
 *   File : why-subscription.js
 *   Author : https://evoqins.com
 *   Description : why subscription details modal component
 *   Integrations : NA
 *   Version : 1.0.0
*/

import { memo } from "react";

// Components
import { Icon } from "../Icon";


function PaymentBreakDownModal(props) {

    // handle close modal
    const _handleCloseModal = () => {
        var button = document.getElementById("subscription-payment-modal-close");
        button.click();
        props.handleClose();
    };

    return (
        <div className="modal fade"
            id="subscription-payment-breakdown-modal"
            data-bs-backdrop="static"
            data-bs-keyboard="false"
            tabIndex="-1"
            aria-labelledby="subscription-payment-breakdown-modal"
            aria-hidden="true">
            <div className="modal-dialog modal-dialog-centered modal-dialog-scrollable border-radius-16 modal-lg px-lg-5">
                <span id='subscription-payment-modal-close' className='d-none' data-bs-dismiss="modal"></span>
                <div className="modal-content border-radius-16 border-0 p-3 mx-lg-5">
                    {/* modal header */}
                    <div className="modal-header border-0 justify-content-between align-items-center p-0">
                        <h6 className="e-alt-font-lato e-font-16 e-text-chinese-black e-font-weight-700 line-height-24px mb-0">
                            Payment Information
                        </h6>
                        <Icon icon="close-icon"
                            size={20}
                            className="cursor-pointer"
                            onPress={_handleCloseModal} />
                    </div>

                    {/* Modal body */}
                    <div className='modal-body p-0 pt-3'>
                        <p className='d-flex justify-content-between e-alt-font-lato e-font-16 e-text-outer-space e-font-weight-400 line-height-18px margin-12px-bottom'>
                            <span>Subscription Fee</span>
                            <span className="e-text-chinese-black e-font-weight-500 e-letter-spacing-min-point-1px">₹{props.breakDownInfo.subscription_fee.toLocaleString("en-IN")}</span>
                        </p>
                        <p className='d-flex justify-content-between e-alt-font-lato e-font-16 e-text-outer-space e-font-weight-400 line-height-18px margin-12px-bottom'>
                            <span>GST (18%)</span>
                            <span className="e-text-chinese-black e-font-weight-500 e-letter-spacing-min-point-1px">₹{props.breakDownInfo.gst.toLocaleString("en-IN")}</span>
                        </p>
                        <p className='d-flex justify-content-between e-alt-font-lato e-font-16 e-text-outer-space e-font-weight-600 line-height-20px mb-3'>
                            <span>Total Paid</span>
                            <span className="e-text-chinese-black e-font-weight-700 e-letter-spacing-min-point-1px">₹{props.breakDownInfo.total.toLocaleString("en-IN")}</span>
                        </p>
                    </div>
                </div>
            </div>
        </div>
    )
}

export default memo(PaymentBreakDownModal);